// extracted by mini-css-extract-plugin
export default {"container":"GX-z","title":"HX-z","link":"IX-z"};